import { SourceType } from '@ui/__generated__/graphql'

export const sourceTypeToLogoAssetSlug: Record<SourceType, string> = {
  [SourceType.CatchAll]: 'otel',
  [SourceType.Datadog]: 'datadog-logs',
  [SourceType.NewRelic]: 'new-relic-agent',
  [SourceType.Otel]: 'otel',
  [SourceType.AwsLambda]: 'aws-lambda',
  [SourceType.Vercel]: 'vercel',
  [SourceType.Fluentbit]: 'fluentbit',
}
